/** Infinite queries backing the "add tracks" picker — the curated library and
 * the org's own uploaded content. */
import { useInfiniteQuery } from '@tanstack/react-query';
import * as api from '../api/mediaApi';

const PAGE_SIZE = 30;

export function useLibraryTracksInfinite(search: string, enabled = true) {
  const q = search.trim();
  return useInfiniteQuery({
    queryKey: ['library', 'tracks', q],
    queryFn: ({ pageParam }) =>
      q
        ? api.searchLibraryTracks({ q, page: pageParam, pageSize: PAGE_SIZE })
        : api.listLibraryTracks({ page: pageParam, pageSize: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.page < last.totalPages ? last.page + 1 : undefined),
    enabled,
  });
}

export function useCustomContentInfinite(search: string, enabled = true) {
  const q = search.trim();
  return useInfiniteQuery({
    queryKey: ['content', 'list', q],
    queryFn: ({ pageParam }) =>
      api.listCustomContent({ q: q || undefined, page: pageParam, pageSize: PAGE_SIZE }),
    initialPageParam: 1,
    getNextPageParam: (last) => (last.page < last.totalPages ? last.page + 1 : undefined),
    enabled,
  });
}
